const cpScript = `
  var s = document.createElement("script")
  s.type = "text/javascript"
  s.async = ""
  s.src="https://js.chilipiper.com/marketing.js"
  document.getElementsByTagName("head")[0].appendChild(s)
`;

// When testing resource hub forms on staging, add { domainLevel: 3 } to the init function

// for prod use the following init function - swap out the init with the code below in both places
// Munchkin.init("894-SZP-051")

// for staging use the following init function - swap out the init with the code below in both places
// Munchkin.init("894-SZP-051", { domainLevel: 3 })

const initMarketoMunchkinWithCP = `
(function () {
  var didInit = false
  function initMunchkin() {
    if (didInit === false) {
      didInit = true
      Munchkin.init("894-SZP-051")
      Munchkin.createTrackingCookie(true)
    }
  }

  function sendClickEventAfterCP() {
      Munchkin.munchkinFunction("clickLink", {
        href: "/Chilipiper/bookedmeeting",
      })
  }

  var s = document.createElement("script")
  s.type = "text/javascript"
  s.async = true
  s.src = "//munchkin.marketo.net/munchkin.js"
  s.onreadystatechange = function() {
    if (this.readyState == 'complete' || this.readyState == 'loaded') {
      initMunchkin();
    }
  };
  s.onload = function () { // once marketo is loaded
    initMunchkin()
      function q(a) {
        return function () {
          ChiliPiper[a].q = (ChiliPiper[a].q || []).concat([arguments]);
        };
      }
      window.ChiliPiper =
        window.ChiliPiper ||
        "submit scheduling showCalendar submit widget bookMeeting"
          .split(" ")
          .reduce(function (a, b) {
            a[b] = q(b);
            return a;
          }, {});
      ChiliPiper.scheduling("helloalma", "m_inbound_router", {
        onSuccess: function (data) {
          sendClickEventAfterCP()
          if (typeof window !== "undefined" && typeof window.gtag == "function") {
            window.gtag("event", "ChiliPiper_booking", { send_to: 'G-R0Z6J0E1GE' })
          }
        },
        map: true,
      })

  }
  document.getElementsByTagName("head")[0].appendChild(s)
})()`;

const initMarketoMunchkin = `
(function () {
  var didInit = false
  function initMunchkin() {
    if (didInit === false) {
      didInit = true
      Munchkin.init("894-SZP-051")
      Munchkin.createTrackingCookie(true)
    }
  }
  var s = document.createElement("script")
  s.type = "text/javascript"
  s.async = true
  s.src = "//munchkin.marketo.net/munchkin.js"
  s.onreadystatechange = function() {
    if (this.readyState == 'complete' || this.readyState == 'loaded') {
      initMunchkin();
    }
  };
  s.onload = function () { // once marketo is loaded
    initMunchkin()
  }
  document.getElementsByTagName("head")[0].appendChild(s)
})()`;

const initDreamData = `
(function() {
  var e = "dreamdata";
  var dreamdata = window[e] = window[e] || [];

  if (!dreamdata.initialize) {
    if (dreamdata.invoked) {
      window.console && console.error && console.error("Dreamdata snippet included twice.");
    } else {
      dreamdata.invoked = true;

      dreamdata.methods = [
        "trackSubmit", "trackClick", "trackLink", "trackForm", "pageview",
        "identify", "reset", "group", "track", "ready", "alias", "debug",
        "page", "screen", "once", "off", "on", "addSourceMiddleware",
        "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware",
        "register"
      ];

      dreamdata.factory = function(t) {
        return function() {
          if (window[e].initialized) {
            return window[e][t].apply(window[e], arguments);
          }

          var a = Array.prototype.slice.call(arguments);
          if (["track", "screen", "alias", "group", "page", "identify"].indexOf(t) > -1) {
            var r = document.querySelector("link[rel='canonical']");
            a.push({
              __t: "bpc",
              c: r && r.getAttribute("href") || void 0,
              p: location.pathname,
              u: location.href,
              s: location.search,
              t: document.title,
              r: document.referrer
            });
          }
          a.unshift(t);
          dreamdata.push(a);
          return dreamdata;
        }
      };

      for (var t = 0; t < dreamdata.methods.length; t++) {
        var a = dreamdata.methods[t];
        dreamdata[a] = dreamdata.factory(a);
      }

      dreamdata.load = function(t, a) {
        var r = document.createElement("script");
        r.id = "dreamdata-analytics";
        r.type = "text/javascript";
        r.async = true;
        r.setAttribute("data-global-dreamdata-analytics-key", e);
        r.src = "https://cdn.dreamdata.cloud/scripts/analytics/next/dreamdata.min.js";

        var i = document.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(r, i);
        dreamdata._loadOptions = a;
      };

      dreamdata._writeKey = "f91f47b5-b2a9-4b2b-936b-2a367775cbba";
      dreamdata.SNIPPET_VERSION = "dreamdata-2.0.1";

      dreamdata.load("f91f47b5-b2a9-4b2b-936b-2a367775cbba", {
        googleEnhancedConversions: true,
        formTracking: {
          html: true
        },
        intentSources: {
          autoGroup: true
        }
      });

      dreamdata.page();
    }
  }
})();
`;

const initDreamDataCL = `
(function() {
  if (!window.dreamdata || !window.dreamdata.initialized) {
    if (window.dreamdata) {
      var e = document.getElementById("dreamdata-analytics");
      if (e && e.type && "text/javascript" == e.type) return;
    }

    var a = "dreamdata-cl";
    var dreamdata = window[a] = window[a] || [];

    if (!dreamdata.initialize) {
      if (dreamdata.invoked) {
        window.console && console.error && console.error("Dreamdata CL snippet included twice.");
      } else {
        dreamdata.invoked = true;
        dreamdata.methods = [
          "trackSubmit", "trackClick", "trackLink", "trackForm", "pageview",
          "identify", "reset", "group", "track", "ready", "alias", "debug",
          "page", "screen", "once", "off", "on", "addSourceMiddleware",
          "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware",
          "register"
        ];

        dreamdata.factory = function(e) {
          return function() {
            if (window[a].initialized) {
              return window[a][e].apply(window[a], arguments);
            }
            var t = Array.prototype.slice.call(arguments);
            if (["track", "screen", "alias", "group", "page", "identify"].indexOf(e) > -1) {
              var r = document.querySelector("link[rel='canonical']");
              t.push({
                __t: "bpc",
                c: r && r.getAttribute("href") || void 0,
                p: location.pathname,
                u: location.href,
                s: location.search,
                t: document.title,
                r: document.referrer
              });
            }
            t.unshift(e);
            dreamdata.push(t);
            return dreamdata;
          }
        };

        for (var t = 0; t < dreamdata.methods.length; t++) {
          var r = dreamdata.methods[t];
          dreamdata[r] = dreamdata.factory(r);
        }

        dreamdata.load = function(e, t) {
          var r = document.createElement("script");
          r.id = "dreamdata-analytics-cl";
          r.type = "text/javascript";
          r.async = true;
          r.setAttribute("data-global-dreamdata-cl-analytics-key", a);
          r.src = "https://cdn.drda.io/scripts/analytics/next/dreamdata.cl.min.js";
          var i = document.getElementsByTagName("script")[0];
          i.parentNode.insertBefore(r, i);
          dreamdata._loadOptions = t;
        };

        dreamdata._writeKey = "f91f47b5-b2a9-4b2b-936b-2a367775cbba";
        dreamdata.SNIPPET_VERSION = "dreamdata-cl-2.0.0";
        dreamdata.load("f91f47b5-b2a9-4b2b-936b-2a367775cbba");
        dreamdata.page();
      }
    }
  }
})();
`;

module.exports = {
	cpScript,
	initDreamData,
	initDreamDataCL,
	initMarketoMunchkin,
	initMarketoMunchkinWithCP,
};
